import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MONTHS } from "@/constants/questionnaire";

interface MonthlyExpansionDialogProps {
  year: "2026" | "2027" | "2028";
  initialData: Record<string, number>;
  onClose: () => void;
  onSave: (data: Record<string, number>) => void;
}

export const MonthlyExpansionDialog = ({ year, initialData, onClose, onSave }: MonthlyExpansionDialogProps) => {
  const [local, setLocal] = useState<Record<string, number>>(() => {
    const data: Record<string, number> = {};
    MONTHS.forEach((m) => { data[m] = initialData[m] || 0; });
    return data;
  });

  const total = Object.values(local).reduce((s, v) => s + (v || 0), 0);

  const handleChange = (month: string, raw: string) => {
    const val = parseInt(raw, 10);
    setLocal((prev) => ({ ...prev, [month]: isNaN(val) ? 0 : val }));
  };

  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Monthly Camera Expansion — {year}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Enter the number of additional cameras planned for each month.
            Total: <span className="font-semibold text-foreground">{total}</span>
          </p>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
            {MONTHS.map((month) => (
              <div key={month} className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">{month}</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={local[month] || ""}
                  onChange={(e) => handleChange(month, e.target.value)}
                  onFocus={(e) => e.target.select()}
                  className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm text-center shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                />
              </div>
            ))}
          </div>
          <div className="flex justify-end">
            <Button onClick={() => onSave(local)}>Done</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
